import { features } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 tracking-wide">特色优势</h2>
          <p className="mt-2 text-sm text-foreground-500">为什么千万用户选择樱花TV？五大核心优势给你答案</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((feature, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg p-6 border border-background-200/70 text-center group cursor-pointer hover:border-primary-400/20 transition-all duration-300"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-primary-500/10 flex items-center justify-center group-hover:bg-primary-500/20 transition-colors">
                <i className={`${feature.icon} text-2xl text-primary-400`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-700 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}